import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = { class: "flex alignC" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "日期", -1)
const _hoisted_5 = { class: "flex alignC cascader" }
const _hoisted_6 = { class: "order-status flex" }
const _hoisted_7 = {
  class: "flex button-group",
  style: {"justify-content":"center"}
}
const _hoisted_8 = { class: "c-60" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "取消", -1)
const _hoisted_10 = { class: "flex flexR mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.selectGroup.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectGroup.date = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'start_date')))
        }, null, 8, ["modelValue", "shortcuts"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.selectGroup.search,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectGroup.search = $event)),
          placeholder: "车牌号/会员ID/手机号",
          "suffix-icon": "el-icon-search",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenChange($event, 'search')))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderStatusNav, (item, index) => {
        return (_openBlock(), _createBlock("p", {
          class: ["mar-r-20", { 'nav-range c-red': index == _ctx.orderStatus }],
          key: index,
          onClick: ($event: any) => (_ctx.orderStatus = index)
        }, _toDisplayString(item.name), 11, ["onClick"]))
      }), 128))
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode("div", _hoisted_7, [
              ((scope.row.status == 0 && _ctx.roleList.accept) || (scope.row.status == 1 && _ctx.roleList.create))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "btgrey",
                    onClick: ($event: any) => (
                                _ctx.columnChange(scope.row.id, scope.row.status == 0 ? true : false, 1)
                            )
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_8, _toDisplayString(scope.row.status == 0 ? "受理" : "新建工单"), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.status == 0 && _ctx.roleList.cancel)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "btgrey",
                    onClick: ($event: any) => (
                                _ctx.columnChange(scope.row.id, true, -1)
                            )
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
}